import instance from "../api/instance";
import { logout } from "./sessionActions";
import { getFilters } from '../../components/utils/functions';
import { GET_ALL_LOGS, CLEAR_ALL_LOGS, GET_LOGS_ACTION_TYPES } from '../constants/constants';

export const getAllLogs = (page = 0, size = 10, userType = 'BSC', filters = []) => {
  var query = getFilters(filters);
  query = (query !== '') ? `&search=${query}` : query;

  var url = userType == 'BSC' ? '/audit-logs' : '/audit-logs/me';

  return dispatch => {
    return instance.post(`${url}`, {page, size, query })
      .then(response => {
        dispatch({
          type: GET_ALL_LOGS,
          logs: response.data.data
        })
      }
      )
      .catch(err => {
        var statusCode = err.response.status;

        switch (statusCode) {
          case 401: // Deslogueamos porque el token es inválido
            dispatch(logout());
            break;
          case 500: // Deslogueamos porque el token es inválido
            dispatch(logout());
            break;
        }
      });
  };
}

export const getActionTypes = () => {
  return dispatch => {
    return instance.get(`/audit-logs/action-types`)
      .then(response => 
        dispatch({
          type: GET_LOGS_ACTION_TYPES,
          actions: response.data.data
        })
      )
      .catch(err => {
        var statusCode = err.response.status;

        switch (statusCode) {
          case 401: // Deslogueamos porque el token es inválido
            dispatch(logout());
            break;
          case 500: // Deslogueamos porque el token es inválido
            dispatch(logout());
            break;
        }
      })
  }
}

export const clearLogs = () => {
  return dispatch => dispatch({
    type: CLEAR_ALL_LOGS
  });
}